/**
 * DynamicFavicon Component
 * 
 * هذا المكون معطل عمداً لمنع التداخل مع:
 * 1. روابط Favicon الثابتة في index.html
 * 2. عناصر SEO المُدارة بواسطة SEOHead.tsx
 * 
 * الـ Favicon يُدار بشكل ثابت في index.html لضمان:
 * - ظهوره في الصفحات المُسبقة العرض (Pre-rendered)
 * - عدم التداخل مع عملية البناء الثابت
 * - التوافق مع جميع المتصفحات
 */
const DynamicFavicon = () => {
  // لا نفعل شيء - الـ favicon ثابت في index.html
  // لا نحذف أي روابط ولا نغير document.title
  // لأن SEOHead يتولى إدارة العنوان لكل صفحة
  return null;
};

export default DynamicFavicon;
